import { HLocalStorage, HUtils, HApi } from "src/core/helpers"
import { MyModal } from "src/core/components"
import MyUIOne from "./MyUI"
import { HCF, HJson } from "@macashipo/mlib"
import { KConfigApp } from "src/helpers/K"
import DevMenu from "./MyUI/Types/dev_menu"
import "./scss/index.scss"

interface IModuleDevSimulator extends IModuleOne {
  usingLocalBaseUrlKey?: any
  localBaseUrlKey?: any
  localConfigKey?: any
  usingLocalBaseUrl?: boolean
  runAfterInit: () => void
  setLocalBaseUrl: (newBaseUrl: any) => void
  setLocalConfig: (newConfigJsonString: any) => void
  getIsUsingLocalBaseUrl: () => boolean
  getLocalBaseUrl: () => string
  getLocalConfig: () => string
  showUIDevSimulator: () => void
  setIsUsingLocalBaseUrl: (value: any) => void
}
const ModuleDevSimulator: IModuleDevSimulator = {
  usingLocalBaseUrlKey: "_usingLocalBaseUrl",
  localBaseUrlKey: "_localBaseUrl",
  localConfigKey: "_localConfig",
  usingLocalBaseUrl: false,
  runAfterInit: () => {
    MyUIOne.init()
    const localBaseUrl = ModuleDevSimulator.getLocalBaseUrl()
    const localConfigJson = ModuleDevSimulator.getLocalConfig()
    const isUsingLocalBaseUrl = ModuleDevSimulator.getIsUsingLocalBaseUrl()
    if (isUsingLocalBaseUrl === true) {
      ModuleDevSimulator.usingLocalBaseUrl = true
      if (localBaseUrl) {
        HCF.setCF(KConfigApp.baseUrl, localBaseUrl)
        HApi.initApi({ baseUrl: localBaseUrl })
      }
    }
    if (localConfigJson) {
      let _localConfig = HJson.getObj(localConfigJson)
      if (_localConfig) {
        HCF.setCFMultiObj(_localConfig)
      }
    }
    if (HUtils.isLocalDev() === true || isUsingLocalBaseUrl === true) {
      HCF.setCF(KConfigApp.isDevMode, true)
      ModuleDevSimulator.showUIDevSimulator()
    } else {
      console.log = () => {}
      console.warn = () => {}
    }
    if (!localBaseUrl) {
      ModuleDevSimulator.setLocalBaseUrl("http://localhost:12391")
    }
  },
  getIsUsingLocalBaseUrl: () => {
    if (
      HLocalStorage.getObj(ModuleDevSimulator.usingLocalBaseUrlKey, {}) === true
    ) {
      return true
    }
    return false
  },
  getLocalBaseUrl: () => {
    return HLocalStorage.getString(ModuleDevSimulator.localBaseUrlKey, "")
  },
  getLocalConfig: () => {
    return HLocalStorage.getString(ModuleDevSimulator.localConfigKey, "")
  },
  setIsUsingLocalBaseUrl: value => {
    ModuleDevSimulator.usingLocalBaseUrl = value
    HLocalStorage.saveString(ModuleDevSimulator.usingLocalBaseUrlKey, value)
  },
  setLocalBaseUrl: newBaseUrl => {
    HLocalStorage.saveString(ModuleDevSimulator.localBaseUrlKey, newBaseUrl)
  },
  setLocalConfig: newConfigJsonString => {
    HLocalStorage.saveString(
      ModuleDevSimulator.localConfigKey,
      newConfigJsonString
    )
  },
  showUIDevSimulator: () => {
    if (!document.getElementById("dev_simulator")) {
      const _localBaseUrl = ModuleDevSimulator.getLocalBaseUrl()
      let div = document.createElement("div")
      div.id = "dev_simulator"
      div.className = "ag-np"
      let button = document.createElement("button")
      button.type = "button"
      button.title = "Show config dev debug"
      button.innerHTML = `<i class='fa fa-bug'/> ${
        ModuleDevSimulator.usingLocalBaseUrl && _localBaseUrl
          ? _localBaseUrl
          : ""
      }`
      button.className = "btn btn-danger btn-dev-sml ag-np"
      button.onclick = function () {
        MyModal.showFromMyUI(
          {
            type: "dev_simulator",
          },
          {
            title: "Config BaseUrl",
          }
        )
      }
      div.appendChild(button)

      let divMenu = document.createElement("div")
      divMenu.id = "dev_menu"
      div.appendChild(divMenu)
      //add div to body
      document.body.appendChild(div)
      document.body.style.position = "relative"

      DevMenu.renderIntoId("dev_menu")
    }
  },
}
export default ModuleDevSimulator
